var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDemolition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34.41 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.45,16.83V14a1.08,1.08,0,0,0-1.07-1.08h-3l-1.62-1.61L28.06,9a.51.51,0,0,0,0-.75L25.75,5.91,28.06,3.6a.51.51,0,0,0,0-.75L25.38.16a.54.54,0,0,0-.76,0L21.94,2.85a.51.51,0,0,0,0,.75l2.31,2.31L21.94,8.23a.51.51,0,0,0,0,.75l2.31,2.31L22.63,12.9h-3A1.08,1.08,0,0,0,18.55,14v2.85a17.2,17.2,0,1,0,12.9,0ZM23.06,3.23,25,1.29l1.94,1.94L25,5.16Zm0,5.37L25,6.67,26.94,8.6,25,10.54ZM25,12l.86.86H24.14Zm0,32.05A11.29,11.29,0,0,1,13.71,32.8a.54.54,0,1,1,1.07,0A10.21,10.21,0,0,0,25,43a.54.54,0,1,1,0,1.08Zm4.3-28a16.09,16.09,0,0,0-4.3-.54,19,19,0,0,0-4.3.54V15.05h8.6v1.08Z",
    transform: "translate(-7.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDemolition);
export default __webpack_public_path__ + "static/media/icon-demolition.ef94622e334b78fbc10c774debca1903.svg";
export { ForwardRef as ReactComponent };